import React from 'react';
import { Box } from '@mui/material';
import NotificationPermissionBanner from './NotificationPermissionBanner';
import { FullScreenIntentPermissionBanner } from './FullScreenIntentPermissionPrompt';
import IosRingtonePermissionBanner from './IosRingtonePermissionBanner';

// Drafts must be checked before their first save, including unchanged defaults.
// These components only read status; OS requests remain explicit button actions.
export default function AlertPermissionNotices({ medications, includeIos = true, onOpenAlertSettings }) {
    const scheduled = medications.filter(med => med.frequencyType !== 'AS_NEEDED');
    if (!scheduled.length) return null;
    const channelIds = ['default'];
    if (scheduled.some(med => med.alertType === 'FULLSCREEN')) channelIds.push('pill-reminder-alarm');
    if (scheduled.some(med => med.alertType === 'VIBRATION')) channelIds.push('pill-reminder-vibration');
    if (channelIds.length > 1) channelIds.push('pill-alarm-foreground-v2');
    return <Box data-alert-permission-notices sx={{ display: 'flex', flexDirection: 'column', gap: 1.5,
        '&:not(:empty)': { my: 1.5 }, '&:empty': { display: 'none' }, '& > [role="status"]': { mb: 0 } }}>
        <NotificationPermissionBanner channelIds={channelIds} />
        <FullScreenIntentPermissionBanner medications={scheduled} source="alert_settings_draft" />
        {includeIos && <IosRingtonePermissionBanner medications={scheduled} onOpenAlertSettings={onOpenAlertSettings} />}
    </Box>;
}
